<template>
  <div class="relative bg-white rounded-xl shadow-sm border border-gray-200 p-2">
    <!-- Remove button -->
    <button
      @click="handleRemove"
      v-if="!loading"
      class="absolute -top-2 -right-2 z-10 bg-red-600 hover:bg-red-700 text-white rounded-full w-8 h-8 flex items-center justify-center transition-colors"
    >
      <i class="material-icons text-lg">close</i>
    </button>





    <!-- Product image -->
    <div class="aspect-square rounded-xl bg-gray-200 relative overflow-hidden">

      <div class="w-full absolute bottom-0 left-0 flex" v-if="!loading && overrideImage">
        <button @click="handleUseImage" class="h-9 bg-[#3B5C77] text-white text-sm font-bold flex-1 flex items-center justify-center">
          Utiliser l'image
        </button>
        <button class="bg-black h-9 w-10 text-white flex items-center justify-center" @click="handleRegenerate">
          <i class="material-icons text-lg">refresh</i>
        </button>
      </div>

       <DialogRoot v-if="displayImage">
         <DialogTrigger class="w-full h-full">
           <div
               class="w-full h-full bg-cover bg-center"
               :style="`background-image: url('${displayImage}')`"
               :class="{ 'opacity-50': loading }"
           ></div>
         </DialogTrigger>
          <DialogPortal>
            <DialogOverlay class="bg-black/50 data-[state=open]:animate-overlayShow fixed inset-0 z-[1500]" />
            <DialogContent class="data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[800px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none z-[2000]">
              <DialogClose class="absolute top-5 right-5 h-10 w-10 text-white flex items-center justify-center"><i class="material-icons text-3xl">close</i></DialogClose>
              <img :src="displayImage" alt="">
            </DialogContent>
          </DialogPortal>
        </DialogRoot>


      <div
        v-else
        class="w-full h-full flex items-center justify-center bg-gray-200"
        :class="{ 'opacity-50': loading }"
      >
        <i class="material-icons text-gray-400 text-4xl">block</i>
      </div>

      <!-- Loading overlay -->
      <div
        v-if="loading"
        class="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-end pb-4 px-4"
      >
        <div class="text-white text-sm font-bold mb-2">Génération en cours</div>
        <div class="w-full h-1 bg-white bg-opacity-30 rounded-full overflow-hidden">
          <div class="h-full bg-striped-blue animate-slide-stripes"></div>
        </div>
      </div>
    </div>

    <!-- Product name -->
    <div class="px-2 pt-1">
      <h3 class="font-medium text-black line-clamp-2" :title="product.name">
        {{ product.name }}
      </h3>
    </div>
  </div>
</template>

<script setup>
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'radix-vue'
import { computed } from 'vue'

const props = defineProps({
  product: {
    type: Object,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  overrideImage: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['remove-product', 'regenerate-product', 'use-image'])

const displayImage = computed(() => {
  if (props.overrideImage) {
    return props.overrideImage
  }
  if (props.product.image && props.product.image.base) {
    return props.product.image.base
  }
  return null
})

const handleRemove = () => {
  emit('remove-product', props.product.id)
}

const handleRegenerate = () => {
  emit('regenerate-product', props.product.id)
}

const handleUseImage = () => {
  emit('use-image', props.product.id)
}
</script>

<style scoped>
.bg-striped-blue {
  background: repeating-linear-gradient(
    90deg,
    #3b82f6 0px,
    #3b82f6 8px,
    #ffffff 8px,
    #ffffff 16px
  );
  background-size: 32px 100%;
}

@keyframes slide-stripes {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 32px 0;
  }
}

.animate-slide-stripes {
  animation: slide-stripes 1s linear infinite;
}
</style>
